/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Product } from './Product.js';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product.js';

/**
 * 
 * @export
 * @interface GetProductListPreviewResponse
 */
export interface GetProductListPreviewResponse {
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetProductListPreviewResponse
     */
    data?: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof GetProductListPreviewResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductListPreviewResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductListPreviewResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetProductListPreviewResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetProductListPreviewResponse interface.
 */
export function instanceOfGetProductListPreviewResponse(value: object): boolean {
    return true;
}

export function GetProductListPreviewResponseFromJSON(json: any): GetProductListPreviewResponse {
    return GetProductListPreviewResponseFromJSONTyped(json, false);
}

export function GetProductListPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductListPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProductFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetProductListPreviewResponseToJSON(value?: GetProductListPreviewResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProductToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

